import { useState } from 'react';
import Sidebar from '../components/Sidebar';

function Analytics() {
  const [dateRange, setDateRange] = useState('30days');

  const stats = [
    {
      label: 'Total Projects',
      value: '47',
      change: '+12% from last month',
      trend: 'up',
      icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10'
    },
    {
      label: 'Active Users',
      value: '124',
      change: '+8% from last month',
      trend: 'up',
      icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z'
    },
    {
      label: 'Prospects Converted',
      value: '23',
      change: '+15% from last month',
      trend: 'up',
      icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
    },
    {
      label: 'Avg Response Time',
      value: '2.4h',
      change: '-18% from last month',
      trend: 'down',
      icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
    },
  ];

  const projectActivity = [
    { month: 'Jan', created: 12, completed: 10 },
    { month: 'Feb', created: 15, completed: 13 },
    { month: 'Mar', created: 18, completed: 16 },
    { month: 'Apr', created: 14, completed: 15 },
    { month: 'May', created: 20, completed: 18 },
    { month: 'Jun', created: 22, completed: 21 },
  ];

  const prospectPipeline = [
    { status: 'New', count: 45, color: '#3B71AA' },
    { status: 'Contacted', count: 32, color: '#F59E0B' },
    { status: 'Qualified', count: 18, color: '#8B5CF6' },
    { status: 'Converted', count: 23, color: '#10B981' },
  ];

  const userEngagement = [
    { day: 'Mon', logins: 85 },
    { day: 'Tue', logins: 92 },
    { day: 'Wed', logins: 78 },
    { day: 'Thu', logins: 95 },
    { day: 'Fri', logins: 88 },
    { day: 'Sat', logins: 45 },
    { day: 'Sun', logins: 38 },
  ];

  return (
    <div className="min-h-screen bg-[var(--color-bg-primary)]">
      <Sidebar />

      <div className="ml-64 p-8">
        {/* Header */}
        <header className="mb-8 fade-in-up">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-display mb-2" style={{ color: 'var(--color-text-primary)' }}>
                Analytics
              </h1>
              <p style={{ color: 'var(--color-text-secondary)' }}>
                Track performance and insights across your platform
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <select
                value={dateRange}
                onChange={(e) => setDateRange(e.target.value)}
                className="px-4 py-2 border rounded-lg"
                style={{
                  backgroundColor: 'var(--color-bg-light)',
                  borderColor: 'var(--color-border)',
                  color: 'var(--color-text-primary)'
                }}
              >
                <option value="7days">Last 7 days</option>
                <option value="30days">Last 30 days</option>
                <option value="90days">Last 90 days</option>
                <option value="year">Last year</option>
              </select>
              <button className="btn-secondary">
                <span className="flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  Export
                </span>
              </button>
            </div>
          </div>
        </header>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="card fade-in-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(59, 113, 170, 0.1)' }}>
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    style={{ color: 'var(--color-primary)' }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d={stat.icon}
                    />
                  </svg>
                </div>
              </div>
              <h3 className="text-sm mb-2" style={{ color: 'var(--color-text-muted)' }}>{stat.label}</h3>
              <p className="text-4xl font-bold text-display mb-1" style={{ color: 'var(--color-primary)' }}>{stat.value}</p>
              <p className={`text-xs flex items-center ${stat.trend === 'up' ? 'text-green-600' : 'text-blue-600'}`}>
                <svg
                  className={`w-4 h-4 mr-1 ${stat.trend === 'down' ? 'rotate-180' : ''}`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                {stat.change}
              </p>
            </div>
          ))}
        </div>

        {/* Charts Row 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          {/* Project Activity Chart */}
          <div className="card fade-in-up delay-400">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold text-display" style={{ color: 'var(--color-text-primary)' }}>
                Project Activity
              </h2>
              <div className="flex items-center space-x-4 text-xs">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 rounded" style={{ backgroundColor: 'var(--color-primary)' }} />
                  <span style={{ color: 'var(--color-text-secondary)' }}>Created</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 rounded" style={{ backgroundColor: 'var(--color-secondary)' }} />
                  <span style={{ color: 'var(--color-text-secondary)' }}>Completed</span>
                </div>
              </div>
            </div>

            {/* Simple Bar Chart Placeholder */}
            <div className="h-64 flex items-end justify-between space-x-4">
              {projectActivity.map((data, i) => (
                <div key={i} className="flex-1 flex flex-col items-center space-y-2">
                  <div className="w-full flex items-end justify-center space-x-1 h-48">
                    <div
                      className="w-1/2 rounded-t transition-all hover:opacity-80"
                      style={{
                        backgroundColor: 'var(--color-primary)',
                        height: `${(data.created / 22) * 100}%`
                      }}
                      title={`Created: ${data.created}`}
                    />
                    <div
                      className="w-1/2 rounded-t transition-all hover:opacity-80"
                      style={{
                        backgroundColor: 'var(--color-secondary)',
                        height: `${(data.completed / 22) * 100}%`
                      }}
                      title={`Completed: ${data.completed}`}
                    />
                  </div>
                  <span className="text-xs" style={{ color: 'var(--color-text-muted)' }}>{data.month}</span>
                </div>
              ))}
            </div>
          </div>

          {/* User Engagement Chart */}
          <div className="card fade-in-up delay-500">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold text-display" style={{ color: 'var(--color-text-primary)' }}>
                User Engagement
              </h2>
              <span className="text-sm" style={{ color: 'var(--color-text-muted)' }}>Daily logins</span>
            </div>

            {/* Simple Line Chart Placeholder */}
            <div className="h-64 flex items-end justify-between space-x-4">
              {userEngagement.map((data, i) => (
                <div key={i} className="flex-1 flex flex-col items-center space-y-2">
                  <div className="w-full flex items-end justify-center h-48">
                    <div
                      className="w-full rounded-t transition-all hover:opacity-80"
                      style={{
                        backgroundColor: 'var(--color-primary)',
                        height: `${(data.logins / 100) * 100}%`
                      }}
                      title={`${data.logins} logins`}
                    />
                  </div>
                  <span className="text-xs" style={{ color: 'var(--color-text-muted)' }}>{data.day}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Charts Row 2 */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Prospect Pipeline */}
          <div className="card fade-in-up delay-600">
            <h2 className="text-xl font-bold text-display mb-6" style={{ color: 'var(--color-text-primary)' }}>
              Prospect Pipeline
            </h2>

            <div className="space-y-4">
              {prospectPipeline.map((stage, i) => (
                <div key={i}>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium" style={{ color: 'var(--color-text-primary)' }}>
                      {stage.status}
                    </span>
                    <span className="text-sm font-bold" style={{ color: stage.color }}>
                      {stage.count}
                    </span>
                  </div>
                  <div className="w-full h-2 bg-[var(--color-bg-elevated)] rounded-full overflow-hidden">
                    <div
                      className="h-full rounded-full transition-all"
                      style={{
                        backgroundColor: stage.color,
                        width: `${(stage.count / 45) * 100}%`
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 pt-6 border-t" style={{ borderColor: 'var(--color-border)' }}>
              <div className="flex items-center justify-between">
                <span className="text-sm" style={{ color: 'var(--color-text-muted)' }}>Total Prospects</span>
                <span className="text-2xl font-bold" style={{ color: 'var(--color-primary)' }}>
                  {prospectPipeline.reduce((sum, stage) => sum + stage.count, 0)}
                </span>
              </div>
            </div>
          </div>

          {/* Top Projects */}
          <div className="card fade-in-up delay-700">
            <h2 className="text-xl font-bold text-display mb-6" style={{ color: 'var(--color-text-primary)' }}>
              Top Projects
            </h2>

            <div className="space-y-4">
              {[
                { name: 'techflow-api-prod', deploys: 47 },
                { name: 'datascale-pipeline', deploys: 32 },
                { name: 'securebase-backend', deploys: 28 },
                { name: 'analytics-dashboard', deploys: 24 },
                { name: 'payment-gateway', deploys: 19 },
              ].map((project, i) => (
                <div key={i} className="flex items-center justify-between p-3 bg-[var(--color-bg-elevated)] rounded-lg border" style={{ borderColor: 'var(--color-border)' }}>
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(59, 113, 170, 0.1)' }}>
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        style={{ color: 'var(--color-primary)' }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                        />
                      </svg>
                    </div>
                    <span className="text-sm font-mono" style={{ color: 'var(--color-text-primary)' }}>
                      {project.name}
                    </span>
                  </div>
                  <span className="text-sm font-bold" style={{ color: 'var(--color-primary)' }}>
                    {project.deploys}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Recent Activity */}
          <div className="card fade-in-up delay-800">
            <h2 className="text-xl font-bold text-display mb-6" style={{ color: 'var(--color-text-primary)' }}>
              Recent Activity
            </h2>

            <div className="space-y-4">
              {[
                { action: 'Project deployed', project: 'techflow-api', time: '2m ago', type: 'success' },
                { action: 'User invited', user: 'john@acme.com', time: '15m ago', type: 'info' },
                { action: 'Prospect converted', company: 'TechStart', time: '1h ago', type: 'success' },
                { action: 'Build failed', project: 'payment-service', time: '2h ago', type: 'error' },
                { action: 'User logged in', user: 'sarah@techflow.com', time: '3h ago', type: 'info' },
              ].map((activity, i) => (
                <div key={i} className="flex items-start space-x-3">
                  <div
                    className={`w-2 h-2 rounded-full mt-2 ${activity.type === 'success' ? 'bg-green-500' : activity.type === 'error' ? 'bg-red-500' : ''}`}
                    style={{ backgroundColor: activity.type === 'info' ? 'var(--color-primary)' : undefined }}
                  />
                  <div className="flex-1">
                    <p className="text-sm" style={{ color: 'var(--color-text-primary)' }}>
                      {activity.action}
                    </p>
                    <p className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
                      {activity.time}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Analytics;
